import React from "react"
import { MuiThemeProvider } from "@material-ui/core/styles"
import createTheme from "theme"

import { create } from "jss"
import preset from "jss-preset-default"
import rtl from "jss-rtl"
import JssProvider from "react-jss/lib/JssProvider"
import createGenerateClassName from "@material-ui/core/styles/createGenerateClassName"

import isRtlClient from "ui-Rtl/isRtlClient"

// Configure JSS
const jss = create({ plugins: [...preset().plugins, rtl()] })
jss.options.createGenerateClassName = createGenerateClassName

if (isRtlClient()) {
  document.dir = "rtl"
}
const defaultTheme = createTheme(document.dir)

export default function Material({ children, theme }) {
  return (
    <JssProvider jss={jss}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </JssProvider>
  )
}

Material.defaultProps = {
  theme: defaultTheme,
}



// WEBPACK FOOTER //
// ../ui-kit/src/Material.js